import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/storage'

import config from '@/config'

const firebaseApp = firebase.initializeApp(config.firebase)

const firestore = firebaseApp.firestore()

function createOrUpdate (collection, payload) {
  let ref = firestore.collection(collection)
  let id = payload.id

  let data = Object.assign({}, payload)
  delete data.id

  if (id) {
    ref = ref.doc(id).update(data)
  } else {
    ref = ref.add(data)
  }

  return ref
    .then((docRef) => {
      return docRef
    })
}

const FieldValue = firebase.firestore.FieldValue

export default firestore

export {
  createOrUpdate,
  firestore,
  FieldValue
}
